// NP-644: `/` and `/dashboard` both render <Index /> (App.tsx), and login lands on
// `/dashboard` rather than `/` (NP-213, so an authenticated user is never left at '/').
// Nav items matched their own `to` exactly, and the Dashboard tab's `to` is `/` — so every
// borrower arriving straight from login saw NO tab highlighted at all. Treating both paths
// as the Dashboard is what keeps the tab lit on whichever one the user landed on.
const DASHBOARD_PATHS = new Set(["/", "/dashboard"]);

// Shared by all three nav surfaces (header pill nav, header mobile sheet, mobile bottom
// nav) so their highlight rules cannot drift apart again.
export function isNavPathActive(to: string, pathname: string): boolean {
  // "/" would prefix-match every route, so the Dashboard tab matches exact paths only.
  if (to === "/") return DASHBOARD_PATHS.has(pathname);
  // Nested routes keep the parent tab lit, e.g. /application/step/personal.
  return pathname === to || pathname.startsWith(`${to}/`);
}
